<!-- eslint-disable @angular-eslint/template/eqeqeq -->
<div class="pr-3 float-right" *ngIf="showSearchInfo || isClassCodeClicked">
  <a class="pdl-link float-right clickable" target="_blank" (click)="print()">
    {{ 'drugNameSearch.print' | translate }}</a
  >
</div>

<div class="new-table">
  <div
    *ngIf="
      (isClassCodeClicked || showSearchInfo) && selectedDrugList.length > 0
    "
    id="tab"
  >
    <p *ngIf="consumerId === 'chcp'">
      {{ 'drugNameSearch.header.hcp' | translate }}
    </p>
    <p *ngIf="consumerId !== 'chcp'">
      {{ 'drugNameSearch.search_method' | translate }}
    </p>
    <br />
    <ng-container *ngIf="consumerId === 'chcp'">
      <label
        class="search-color"
        *ngIf="showSearchInfo && !isClassCodeClicked"
        [innerHTML]="
          'drugNameSearch.result_info.hcp.searched_list'
            | translate : { searchString: alphabet }
        "
      ></label>
      <label
        class="search-color"
        *ngIf="isClassCodeClicked"
        [innerHTML]="
          'drugNameSearch.result_info.hcp.searched_list'
            | translate : { searchString: selectedDrugList[0].therapeuticClass }
        "
      >
      </label>
    </ng-container>
    <ng-container *ngIf="consumerId !== 'chcp'">
      <label
        class="search-color"
        *ngIf="isClassCodeClicked"
        [innerHTML]="
          'drugNameSearch.result_info.cigna.filtered_list'
            | translate
              : {
                  searchString: selectedDrugList[0].therapeuticClass,
                  selectedDrugList: selectedItem.display
                }
        "
      >
      </label>
      <label
        class="search-color"
        *ngIf="showSearchInfo && !isClassCodeClicked"
        [innerHTML]="
          'drugNameSearch.result_info.cigna.filtered_list'
            | translate
              : {
                  searchString: alphabet,
                  selectedDrugList: selectedItem.display
                }
        "
      >
      </label>
    </ng-container>
    <br />
    <br />
    <table class="table drug-doublerow-table">
      <tr>
        <th>
          {{ 'drugNameSearch.drugs_grid_header.drug_name' | translate }}
        </th>
        <th>{{ 'drugNameSearch.drugs_grid_header.strength' | translate }}</th>
        <th>
          {{ 'drugNameSearch.drugs_grid_header.dosage_form' | translate }}
        </th>
        <th>
          {{ 'drugNameSearch.drugs_grid_header.class' | translate }}
        </th>
        <th class="col4">
          {{ 'drugNameSearch.drugs_grid_header.tier' | translate }}
        </th>
        <th>{{ 'drugNameSearch.drugs_grid_header.notes' | translate }}</th>
      </tr>
      <ng-container *ngFor="let drug of selectedDrugList">
        <tr class="trow">
          <td class="td-data">
            {{ drug.drugName }}
          </td>
          <td class="td-data p-0">
            <ng-container>
              <table class="row-width">
                <tr *ngFor="let strength of drug.strength">
                  <td class="ft-child" *ngIf="strength">
                    {{ strength }}
                  </td>
                  <td class="ft-child" *ngIf="!strength">&#8203;</td>
                </tr>
              </table>
            </ng-container>
          </td>
          <td class="td-data p-0">
            <ng-container *ngIf="consumerId === 'chcp'; else nonChcp">
              <table class="row-width">
                <tr *ngFor="let dosageFormDesc of drug.dosageFormDesc">
                  <td class="ft-child" *ngIf="dosageFormDesc">
                    {{ dosageFormDesc }}
                  </td>
                  <td class="ft-child" *ngIf="!dosageFormDesc">&#8203;</td>
                </tr>
              </table>
            </ng-container>
            <ng-template #nonChcp>
              <table class="row-width">
                <tr *ngFor="let dosageForm of drug.dosageForm">
                  <td class="ft-child" *ngIf="dosageForm">
                    {{ dosageForm }}
                  </td>
                  <td class="ft-child" *ngIf="!dosageForm">&#8203;</td>
                </tr>
              </table>
            </ng-template>
          </td>
          <td class="td-data pl-2 word-brk clickable pdl-link">
            {{ drug.therapeuticClass }}
          </td>
          <td class="td-data p-0">
            <table class="row-width">
              <ng-container *ngFor="let tier of drug.tier">
                <tr>
                  <td class="ft-child" *ngIf="tier">
                    {{ tier }}
                  </td>
                  <td class="ft-child" *ngIf="!tier">&#8203;</td>
                </tr>
              </ng-container>
            </table>
          </td>
          <td class="td-data p-0">
            <table class="row-width">
              <ng-container *ngFor="let data of drug.notes">
                <tr>
                  <td class="ft-child" *ngIf="data.length > 0">
                    <ng-container *ngFor="let note of data; index as i">
                      {{ note }}
                      <label *ngIf="data.length > 1 && i != data.length - 1"
                        >,</label
                      >
                    </ng-container>
                  </td>
                  <td class="ft-child" *ngIf="data.length === 0">&#8203;</td>
                </tr>
              </ng-container>
            </table>
          </td>
        </tr>
      </ng-container>
    </table>
    <br />
    <div *ngIf="notesCollection?.length > 0">
      <small [innerHTML]="'drugNameSearch.notes.sub_info' | translate"></small>
    </div>
    <br />
    <div class="notes-list">
      <li class="d-table-row" *ngFor="let noteVal of notesCollection">
        <div class="d-table-cell">
          <b>{{ noteVal }}</b>
        </div>
        &nbsp; &nbsp; &nbsp;
        <div class="d-table-cell">
          <ng-container *ngIf="!['SD', 'SDS'].includes(noteVal)">
            <b>{{
              'drugNameSearch.notes.' + noteVal + '.long_form' | translate
            }}</b
            >: &nbsp;
            <span>
              {{
                'drugNameSearch.notes.' + noteVal + '.description' | translate
              }}
            </span>
          </ng-container>
          <ng-container *ngIf="noteVal === 'SDS'">
            <span *ngIf="msdLimitValue === rsdLimitValue; else dayLimit">
              <b>
                {{
                  'drugNameSearch.notes.' + noteVal + '.long_form' | translate
                }}: &nbsp;</b
              >
              {{
                'drugNameSearch.notes.SDS.description_XX'
                  | translate : { msdLimit: msdLimitValue }
              }}"
            </span>
            <ng-template #dayLimit>
              <span>
                <b>
                  {{
                    'drugNameSearch.notes.' + noteVal + '.long_form'
                      | translate
                  }}: &nbsp;</b
                >
                {{
                  'drugNameSearch.notes.SDS.description_XY'
                    | translate
                      : { rsdLimit: rsdLimitValue, msdLimit: msdLimitValue }
                }}
              </span>
            </ng-template>
          </ng-container>
          <ng-container *ngIf="noteVal === 'SD'">
            <span
              *ngIf="
                otherInfo.mailSpecialtyDaySupply ===
                  otherInfo.retailSpecialtyDaySupply;
                else daySupply
              "
            >
              <b>
                {{
                  'drugNameSearch.notes.' + noteVal + '.long_form' | translate
                }}:&nbsp;</b
              >
              {{
                'drugNameSearch.notes.SD.description_XX'
                  | translate : { msdSupply: otherInfo.mailSpecialtyDaySupply }
              }}"
            </span>
            <ng-template #daySupply>
              <span>
                <b>
                  {{
                    'drugNameSearch.notes.' + noteVal + '.long_form'
                      | translate
                  }}: &nbsp;</b
                >
                {{
                  'drugNameSearch.notes.SD.description_XY'
                    | translate
                      : {
                          rsdSupply: otherInfo.retailSpecialtyDaySupply,
                          msdSupply: otherInfo.mailSpecialtyDaySupply
                        }
                }}
              </span>
            </ng-template>
          </ng-container>
          <hr />
        </div>
      </li>
    </div>
  </div>
</div>
